<div fxLayout="row">
    <h3 lass="mb-0" fxFlex>Submitted Test Images</h3>

    <button *ngIf = "company" mat-button [routerLink]="['/reserved/add-test-image', company.id ]" routerLinkActive="router-link-active" mat-button color="primary">New Test Image</button>
</div>

<ng-template #loadingGeneral>
    <mat-spinner class="center"></mat-spinner>
    <p class="center">Loading...</p>
</ng-template>

<ng-container *ngIf="loggedUser.role === 'admin'">
    <mat-form-field>
        <mat-label>Choose a company</mat-label>
        <mat-select [(value)]="company" (selectionChange)="getTestImageListByCompany()">
            <mat-option *ngFor="let comp of companiesList" [value]="comp">{{comp.companyName}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</ng-container>

<ng-container *ngIf="!loading else loadingGeneral">

    <table *ngIf="company" mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort multiTemplateDataRows>

        <ng-container matColumnDef="id">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
            <td *matCellDef="let element" mat-cell> {{element.id}} </td>
        </ng-container>

        <ng-container matColumnDef="title">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Title</th>
            <td *matCellDef="let element" mat-cell> {{element.title}} </td>
        </ng-container>

        <ng-container matColumnDef="cia">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>CIA</th>
            <td *matCellDef="let element" mat-cell>
                <mat-chip class="colored-chip" matTooltip="{{ getCIATooltip(element) }}" matTooltipClass="break-line-tooltip">
                    <span *ngFor="let letter of getCIAArray()"
                        [ngStyle]="{'color': checkCIA(element, letter) ? 'white' : '#ffffffbf', 'font-weight': checkCIA(element,letter) ? '550' : 'unset'}">
                        {{ letter }}
                    </span>
                </mat-chip>
            </td>
        </ng-container>

        <ng-container matColumnDef="stride">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>STRIDE</th>
            <td *matCellDef="let element" mat-cell>
                <mat-chip class="colored-chip" matTooltip="{{ getSTRIDETooltip(element) }}" matTooltipClass="break-line-tooltip">
                    <span *ngFor="let letter of getSTRIDEArray()"
                        [ngStyle]="{'color': checkSTRIDE(element, letter) ? 'white' : '#ffffffbf', 'font-weight': checkSTRIDE(element,letter) ? '550' : 'unset'}">
                        {{ letter }}
                    </span>
                </mat-chip>
            </td>
        </ng-container>

        <ng-container matColumnDef="regulations">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Regulations</th>
            <td *matCellDef="let element" mat-cell> 
                <mat-chip-listbox>
                    <ng-container *ngFor="let unece of element.regulations
                    ">
                        <mat-chip class="unece-chip" matTooltip="{{ extractTextUnece(unece) }}">
                            {{ extractSLT(unece) }} 
                        </mat-chip>
                    </ng-container>
                </mat-chip-listbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
            <td *matCellDef="let element" mat-cell>
                <button (click)="details(element)" mat-icon-button matTooltip="Show Details">
                    <mat-icon>visibility</mat-icon>
                </button>
                <button (click)="expandVariations(element)" mat-icon-button matTooltip="Show Available Variations">
                    <mat-icon>grid_view</mat-icon>
                </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedVariations">
            <td *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="p-1" mat-cell>
                <div fxLayout="row">
                    <h3 class="mb-0" fxFlex>Available Variations</h3>
                    <button (click)="expandedVariations = undefined" mat-button>Close</button>
                </div>
                <table mat-table [dataSource]="element.variations" class="mat-elevation-z8" multiTemplateDataRows>

                    <ng-container matColumnDef="testname">
                        <th mat-header-cell *matHeaderCellDef> Testname </th>
                        <td mat-cell *matCellDef="let elem"> {{elem.testname}} </td>
                    </ng-container>

                    <ng-container matColumnDef="iface">
                        <th mat-header-cell *matHeaderCellDef> Interface </th>
                        <td mat-cell *matCellDef="let elem"> {{elem.iface}} </td>
                    </ng-container>

                    <ng-container matColumnDef="target">
                        <th mat-header-cell *matHeaderCellDef> Target </th>
                        <td mat-cell *matCellDef="let elem"> {{elem.target}} </td>
                    </ng-container>

                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let elem"> {{elem.testdescription}} </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef>  </th>
                        <td mat-cell *matCellDef="let elem"> 
                            <ng-container *ngIf="elem.dependencyStatus === 'not ok'">
                                <button mat-icon-button matTooltip="Add dependencies" (click)="addDependenciesTest(element.id, elem.testname)">
                                    <mat-icon>library_add</mat-icon>
                                </button>
                            </ng-container>
                            <button mat-icon-button (click)="deleteVariation(element.id, elem.testname)" matTooltip="Delete Variation">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsVariations"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsVariations;"></tr>
                </table>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr *matRowDef="let row; columns: ['expandedVariations']" [fxShow]="expandedVariations?.id === row.id" mat-row></tr>
        <div class="mat-row" *matNoDataRow>
            <div class="mat-cell">No teslist available</div>
        </div>

    </table>

    <mat-paginator *ngIf="company"
                [pageSizeOptions]="[15, 20, 25]"
                (page)="handlePageEvent($event)"
                [pageIndex]="pageNumber - 1"
                [pageSize]="pageSize"
                [length]="testCounter"
                 aria-label="Select page of periodic elements">
    </mat-paginator>

</ng-container>